"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _QRCodeImg = require("./QRCodeImg");
Object.keys(_QRCodeImg).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _QRCodeImg[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _QRCodeImg[key];
    }
  });
});